/*
 * @Author: zjw
 * @Date: 2021-06-10 15:49:14
 * @LastEditTime: 2022-11-15 18:13:22
 * @FilePath: \web-app\src\network\other\workOrder.js
 * @Environment: Vue + Element
 * @Description: 工单管理
 */
import {
    request,
} from '../request.js'

// 列表
export function workOrderList(data) {
    return request({
        url: '/web/back/sys/order/list',
        method: 'post',
        data
    })
}
